module.exports = __webpack_public_path__ + "static/media/04_MICS-1.4-EC-8 1.34bb763f.svg";